import "./suggestions.css";

export const Suggestions = ({ suggestions = [], onSuggestionClick = () => {} }) => {
    const getSuggestionText = (itm) => {
        let suggestions = [...itm.displayLines];
        if (suggestions.length) {
            suggestions[0] = `<b>${suggestions[0]}</b>`;
        }
        return suggestions.join(", ");
    };

    return (
        <div className="suggestionsContainer">
            {suggestions.length > 0 && (
                <div className="searchSuggestions">
                    <ul>
                        {suggestions.map((itm, idx) => (
                            <li
                                onClick={() => {
                                    onSuggestionClick(itm,idx);
                                }}
                                className="clickable"
                                key={idx}
                                dangerouslySetInnerHTML={{ __html: getSuggestionText(itm) }}></li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};
